<template>
  <section class="margin-top-s campaign-container">
    <div v-if="diffSalesTrack > 0" class="flex w100" style="padding-top: 4px; padding-bottom: 4px;">
        <p><b>Atenção:</b> {{ diffSalesTrack | number }} vendas sem <b>TRACKEAMENTO</b>. Confira se a configuração de UTMS está correta.</p>
    </div>
    <div v-if="campaignsFilter && campaignsFilter.length > 0" class="flex middle w100">
      <div class="flex-3  flex middle">
        <div class="button secondary" @click="cleanSelectCamp()">Limpar Seleção</div>
      </div>
    </div>
    <!-- Barra de rolagem superior -->
    <div class="scrollbar-top">
        <div class="scroll-content"></div>
    </div>
    
    <div class="box campaigns">
      <div class="box-content">
        <ul class="list-itens" :class="{item10: isMax10, item20: isMax20,  item30: isMax30,  }">
          
          <li>
            <div class="flex between">
              <div class="flex-3 elem-name">
                  <b>Nome da Campanha</b>
              </div>
              <div class="elem-first-stats flex-1 txt-center">
                  <b>Orçamento</b>
              </div>
              <div 
                v-for="(item, k) in columnsOrder"
                :key="k"
                v-show="columns[item.name]"
                class="flex-1 txt-center"
              >
                <b>{{ item.label }}</b>
                <span class="info tooltip" v-if="item.tooltip">
                    <span class="tooltiptext">{{ item.tooltip }}</span>
                </span>
              </div>
            </div>
          </li>

          <li v-for="(camp, index) in campaigns" :key="index" class="flex middle w100">
            <div class="flex middle w100" :class="{selected: camp.selected}">
              <!-- name -->
              <div class="flex-3 elem-name flex middle" :class="{selected: camp.selected}">
                <div class="flex middle" >
                  <div class="flex middle">
                    <input type="checkbox" v-model="camp.selected" @change="changeSelectedCamp(camp)"/>
                  </div>
                  <div style="margin-left: 8px">
                    <m-switch
                        v-if="camp.platform == 'FBADS'"
                        v-model="camp.status"
                        @change="showModalSwitchStatus=true;selectedCamp=camp;"
                    ></m-switch>
                  </div>
                  <div class="flex column name" style="margin-left: 8px">
                    <div class="flex max-name middle">
                      <p>
                        <i
                          v-if="camp.platform === 'FBADS'"
                          class="fa fa-facebook-square fbads"
                        ></i>
                        <i
                          v-if="camp.platform === 'GADS'"
                          class="fab fa-google gads"
                        ></i>
                        {{ camp.name  | protect }}
                      </p>
                      <div 
                        v-if="camp.platform === 'FBADS'"
                        class="btn-copy"
                        @click="openDuplicateCamp(camp)"><i class="far fa-copy"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- orçamento -->
              <div class="elem-first-stats flex-1 txt-center">
                <div v-if="camp.type === 'CBO'" class="flex center">
                  <money 
                    class="flex input"
                    style="max-width: 100px"
                    v-model="camp.daily_budget"
                    v-bind="money"
                    :disabled="true"
                    >
                  </money>
                  <div class="button secondary edit-money" @click="selectedCamp=camp;showUpdateModal=true">
                    <i class="fas fa-edit"></i>
                  </div>
                </div>
                <div v-else style="min-width: 183px;">
                  ABO
                </div>
              </div>
              <div 
                v-for="(item, k) in columnsOrder"
                :key="k"
                v-show="columns[item.name]"
                class="flex-1 txt-center"
              >
                <div v-if="['roas', 'profit', 'profit_value'].includes(item.name)">
                  <!-- roas -->
                  <div  v-if="item.name == 'roas'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('roas', camp.id) < 1, positive:  getValueC('roas', camp.id) >= 1 }" >
                        {{ getValueC('roas', camp.id) | number }}x
                      </span>
                  </div>
                  <!-- profit -->
                  <div  v-if="item.name == 'profit'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('profit', camp.id) <= 0, positive:  getValueC('profit', camp.id) > 0 }" >
                        {{ getValueC('profit', camp.id) | number }}%
                      </span>
                  </div>
                  <!-- profit_value -->
                  <div  v-if="item.name == 'profit_value'" class="flex-1 txt-center">
                      <span  class="tag" :class="{ negative:  getValueC('profit_value', camp.id) <= 0, positive:  getValueC('profit_value', camp.id) > 0 }" >
                        {{ getValueC('profit_value', camp.id) | money }}
                      </span>
                  </div>
                </div>
                <div v-else>
                  <span v-if="item.filter && item.filter=='money'" >
                    {{  getValueC(item.name, camp.id) | money }}<span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                  <span v-else>
                    {{  getValueC(item.name, camp.id) | number }}<span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>

    <div class="flex-1 flex row w100 middle">
      <div class="flex w100 center filters-groupo-holder">
        <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <!-- modal confirm update -->
    <modal-confirm
      :show="showModalSwitchStatus"
      description="Você tem certeza que deseja alterar o Status?"
      @cancel="
        selectedCamp.status = !selectedCamp.status;
        showModalSwitchStatus = false;
        selectedCamp = null;
      "
      @accept="changeStatusCampaign(selectedCamp)"
    ></modal-confirm>

      <!-- modal confirm duplicate -->
    <modal-confirm
      :show="showModalDuplicate"
      description="Você tem certeza que deseja DUPLICAR a CAMPANHA?"
      @cancel="
        showModalDuplicate = false;
        selectedCamp = null;
      "
      @accept="duplicateCampaign(selectedCamp)"
    ></modal-confirm>

      <modal
        title="Duplicar Campanha"
        :show="showModalDuplicate"
        @close="closeDuplicateCamp()"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form v-if="selectedCamp" autocomplete="off" class="w100">
              <div class="flex-1 w100 margin-top-m">
                Campanha: {{ selectedCamp.name }}
              </div>
              <div class="flex-1 w100 margin-top-m">
                <label>Quantidade de copias:</label>
                <input
                    class="input"
                    id="order"
                    type="number"
                    v-model="qtnDuplicateCampaign"
                    autocomplete="off"
                    :disabled="loadingDuplicate"
                    max="10"
                    min="1"
                  />
              </div>
            </form>
            <div v-if="!loadingDuplicate" class="flex w100 center margin-top-l">
              <div class="button secondary" @click="closeDuplicateCamp()">CANCELAR</div>
              <div class="button primary" @click="duplicateCampaignFBADS(selectedCamp, qtnDuplicateCampaign)" style="margin-left: 8px">DUPLICAR</div>
            </div>
            <div v-else class="flex column miidle w100 center margin-top-l">
              <p><b>Atenção:</b> Duplicando campanha... Aguarde</p>
              <content-loading>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
              </content-loading>
            </div>
          </div>
        </div>
    </modal>

    <modal
        title="Editar Orçamento"
        :show="showUpdateModal"
        @close="showUpdateModal=false;selectedCamp=null"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form v-if="selectedCamp" autocomplete="off" class="w100">
              <div class="flex-1 w100 margin-top-m">
                Campanha: {{ selectedCamp.name }}
              </div>
              <div class="flex-1 w100 margin-top-m">
                <label>Orçamento:</label>
                <money v-model="selectedCamp.daily_budget" v-bind="money"></money>
              </div>
            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button secondary" @click="showUpdateModal=false;selectedCamp=null">CANCELAR</div>
              <div class="button primary" @click="changeBulletCampaign(selectedCamp)" style="margin-left: 8px">SALVAR</div>
            </div>
          </div>
        </div>
    </modal>

  </section>
</template>

<script>
import MSwitch from "@/components/MSwitch.vue";
import ModalConfirm from "@/components/modal/ModalConfirm";
import Modal from "@/components/modal/Modal";

import { Money } from 'v-money'

import {
  getCampaignsFacebook,
  getCampaignsGoogle,
  updateStatusFBADS,
  updateStatusGADS,
  updateBulletFBADS,
  updateBulletGADS,
  duplicateCampaignFBADS
} from "@/services/campaigns";

import {
  getReportCampaigns,
} from "@/services/campaignsReport";

import { mapState } from "vuex";



export default {
  name: "campaign",
  components: {
    MSwitch,
    ModalConfirm,
    Money,
    Modal
  },
  props: [
    'filters',
    'columns',
    'columnsOrder',
    'accountsFilter',
    'campaignsFilter'
  ],
  data() {
    return {
      loading: false,
      loadingDuplicate: false,
      showModalSwitchStatus: false,
      showUpdateModal: false,
      qtnDuplicateCampaign: 1,
      showModalDuplicate: false,
      selectedCamp: null,
      campaigns: [],
      reportCampaigns: {},
      stats: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      totalItens: 0,
      offset: 20,
      page: 1,
    };
  },
  mounted() {
    this.getAllCampaigns();
    this.getReportCampaigns();

    this.syncScrools()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    totalPages() {
      let valueMode = this.totalItens % this.offset;
      let value = this.totalItens / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    diffSalesTrack() {
      if (!this.stats.sales) {
        return 0
      }

      return this.stats.sales - this.stats.lh_sales
    },
    isMax10() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 10;
    },
    isMax20() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 20;
    },
    isMax30() {
      if (!this.columns) return false
      return Object.values(this.columns).reduce((acc, v) => acc + (v === true ? 1 : 0), 0) > 30;
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.campaigns = []
        this.getAllCampaigns()
        this.getReportCampaigns()
      },
    },
    "page": {
      handler() {
        this.campaigns = [];
        this.getAllCampaigns();
      }
    },
    campaignsFilter: {
      handler(value) {
        if (value && value.length === 0) {
          this.campaigns.forEach(c => c.selected = false)
        }
      }
    }
  },
  methods: {
    openDuplicateCamp(camp) {
      this.showModalDuplicate = true
      this.selectedCamp = camp
    },
    closeDuplicateCamp() {
      this.showModalDuplicate = false
      this.selectedCamp = null
      this.qtnDuplicateCampaign = 1
      this.loadingDuplicate = false
    },
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    syncScrools() {
      const campaignDiv = document.querySelector('.campaigns');
      const listItens = document.querySelector('.list-itens');
      const scrollContent = document.querySelector('.scrollbar-top .scroll-content');
      const topScrollbar = document.querySelector('.scrollbar-top');

      // Função para sincronizar o scroll
      function syncScrollbars() {
          // Sincronizar a rolagem
          topScrollbar.scrollLeft = campaignDiv.scrollLeft;

          // Ajustar a largura da barra de rolagem superior para ser a mesma que a do conteúdo
          // scrollContent.style.width = listItens.scrollWidth + 'px';
          scrollContent.style.width = listItens.scrollWidth + 'px';
          scrollContent.style.height = '10px';
      }

      //Adicionar evento de rolagem para sincronizar as barras
      campaignDiv.addEventListener('scroll', () => {
          topScrollbar.scrollLeft = campaignDiv.scrollLeft;
      });

      // Adicionar evento de rolagem para sincronizar as barras
      topScrollbar.addEventListener('scroll', () => {
        campaignDiv.scrollLeft = topScrollbar.scrollLeft;
      });

      // Sincronizar ao carregar a página e ao redimensionar a janela
      window.addEventListener('load', syncScrollbars);
      window.addEventListener('resize', syncScrollbars);
    },
    getValueC(attr, campId) {
      if (!this.reportCampaigns[campId]) {
        return 0
      }

      return this.reportCampaigns[campId][attr]
    },
    changeSelectedCamp(camp) {
      if (camp.selected) {
        // camp selected
        this.$emit('campaignSelected', camp.id)
      } else {
        // camp not selected
        this.$emit('campaignRemoved', camp.id)
      }
    },
    cleanSelectCamp() {
      this.$emit('cleanCampaignSelect')
    },
    changeStatusCampaign(camp){
      if (camp.platform === 'FBADS') {
        this.updateStatusFBADS(camp)
      } else if(camp.platform === 'GADS') {
        this.updateStatusGADS(camp)
      }

      this.showModalSwitchStatus = false;
      this.selectedCamp = null;
    },
    changeBulletCampaign(camp){
      // console.log('camp', camp)
      if (camp.platform === 'FBADS') {
        this.updateBulletFBADS(camp)
      } else if(camp.platform === 'GADS') {
        this.updateBulletGADS(camp)
      }

      this.showUpdateModal = false;
      this.selectedCamp = null;
    },
    getReportCampaigns() {
      const date = this.filters && this.filters.data && this.filters.data.date;

      let params = {
          start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
          end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
          tracking: this.filters && this.filters.data.tracking,
      };
      getReportCampaigns(params)
        .then((result) => {
          this.reportCampaigns = result.campaigns

          this.stats = result.stats
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    getAllCampaigns() {
      this.loading = true
      const date = this.filters && this.filters.data && this.filters.data.date;
      const filterData = this.filters && this.filters.data;

      let params = {
        page: this.page,
        offset: this.offset,
        order: filterData.order,
        order_by: filterData.order_by,
        tracking: filterData.tracking,
        accounts: this.accountsFilter && this.accountsFilter.join(','),
      }
      if (date) {
        params = Object.assign(params,{
          start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
          end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        })
      }
      this.totalItens = 0
      Promise.all([
        getCampaignsFacebook(params)
          .then((result) => {
            this.totalItens += result.total
            this.campaigns = this.campaigns.concat(result.campaigns.map((c) => {
              return { ...c, platform: "FBADS", selected: false, };
            }));

            this.campaigns.forEach(e => {
              if (this.campaignsFilter.includes(e.id) && e.platform === 'FBADS') {
                e.selected = true
              }
            });
          }),
        getCampaignsGoogle(params)
        .then((result) => {
          this.totalItens += result.total
          this.campaigns = this.campaigns.concat(result.campaigns.map((c) => {
            return { ...c, platform: "GADS", selected: false, };
          }));

          this.campaigns.forEach(e => {
              if (this.campaignsFilter.includes(e.id) && e.platform === 'GADS' ) {
                e.selected = true
              }
          });
        })
      ])
      .catch((error) => {
        if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
          title: "Erro",
            message: "Falhou ao buscar campanhas",
          });
      })
      .finally(() => {
        this.loading = false;
      })
    },
    duplicateCampaignFBADS(camp, qtn) {
      let params = {
          campaign_id: camp.id,
          ad_account_id: camp.ad_account_id,
          status: camp.status,
          qtn: qtn,
      }

      this.loadingDuplicate= true

      duplicateCampaignFBADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha duplicada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.closeDuplicateCamp()
          this.$emit('refresh', {})
        })
    },
    updateStatusFBADS(camp) {
      let params = {
          type: 'CAMPAIGN',
          id: camp.id,
          ad_account_id: camp.ad_account_id,
          status: camp.status,
      }

      updateStatusFBADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    updateStatusGADS(camp) {
      let params = {
          type: 'CAMPAIGN',
          id: camp.id,
          ad_account_id: camp.ad_account_id,
          status: camp.status,
      }

      updateStatusGADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    updateBulletFBADS(camp) {
      let params = {
          type: 'CAMPAIGN',
          id: camp.id,
          ad_account_id: camp.ad_account_id,
          bullet: camp.daily_budget,
      }

      updateBulletFBADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    updateBulletGADS(camp) {
      let params = {
          type: 'CAMPAIGN',
          id: camp.id,
          ad_account_id: camp.ad_account_id,
          bullet: camp.daily_budget,
      }

      updateBulletGADS(params)
        .then((result) => {
          console.log('result', result)
          this.$toast.success({
            title:'Sucesso',
            message:'Campanha editada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
  }
};
</script>

<style lang="scss" scoped>
.list-itens {
  min-width: 1500px;
  
  li {
    list-style-type: none;
    padding: 8px 4px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    min-height: 53px;
  }

  &.item10 {
    min-width: 3000px;
  }
  &.item20 {
    min-width: 5000px;
  }
  &.item30 {
    min-width: 6000px;
  }
}



.campaigns {
  // overflow-x:scroll;
  width: 100%;
  overflow-x: auto;
  
  .input {
    height: 36px;
    min-width: 140px;
    text-align: center;
  }
}

.fbads {
  color: blue;
}
.gads {
  color: red
}
.edit-money {
  padding: 8px !important;
  margin-left: 4px;
  border:0 px !important;
}
.input.input:disabled {
  color: var(--primary)
}
.lh-color {
  color: var(--terciary);
  font-weight: 800;
  background: #ededed;
  // border: 1px solid #c3c3c3;
  padding: 8px 4px;
  // border-radius: 5px;
  // margin-right: 4px;
}


.elem-name {
  width: 550px;
  position: absolute;
  background: var(--boxbg);
  height: 36px;
  padding-right: 20px;
  z-index: 2;
  left: 0px;
  padding-left:24px;
        overflow-x: scroll;



  .name {
    padding-right: 8px;
    .max-name {

    }
  }
}

.elem-first-stats {
  margin-left: 500px;
}


/* Estilos básicos para a div principal */
.campaign-container {
}

/* Estilo para a barra de rolagem superior */
.scrollbar-top {
    overflow-x: auto;
    overflow-y: hidden;
    height: 20px; /* Tamanho da barra de rolagem */
    margin-bottom: 10px;

    .scroll-content {
      width: 5000px;
    }
}

/* Estilo para a div de conteúdo com classe campaign */
.campaigns {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-bottom: 28px;
    max-height: 1400px;
}

.selected {
  // background: #e8e8e8;
  background: #EDF2F4;

}


.lh-info {
  //min-width: 840px;
}

ul::-webkit-scrollbar {
  width: 10px !important;
  height: 25px !important;
}
ul::-webkit-scrollbar-thumb {
    background-color: #b12031;
    border-radius: 20px;
    border: 10px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
}


.tag {
  background: #22222212;
  padding: 4px 8px;
  border-radius: 8px;
}

.negative {
  color: red;
}
.positive {
  color: green
}

.btn-copy {
  cursor: pointer;
  margin-left:8px;
  &:hover {
    color: var(--primary);
  }
}


@media screen and (max-width: 1024px) {
  .elem-name {
    position: relative !important;
    width: 500px !important;
  }
  .elem-first-stats {
    margin-left: 0px !important;
  }
}


</style>
